// The SignalR client is loaded as a plain script tag, so it arrives as a global rather than as a module.
// Its own typings are written for module imports and cannot be used from a `module: none` project, so this
// declares the handful of members this front-end actually calls.
declare namespace signalR {
    interface HubConnection {
        on(methodName: string, handler: (payload: any) => void): void;
        invoke<T>(methodName: string, ...args: any[]): Promise<T>;
        start(): Promise<void>;
        onclose(callback: () => void): void;
        onreconnecting(callback: () => void): void;
        onreconnected(callback: () => void): void;
    }

    interface HubConnectionOptions {
        withCredentials?: boolean;
    }

    class HubConnectionBuilder {
        withUrl(url: string, options?: HubConnectionOptions): HubConnectionBuilder;
        withAutomaticReconnect(): HubConnectionBuilder;
        build(): HubConnection;
    }
}
